var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LookerDashboardComponent", {
    attrs: {
      maintenance: false,
      url: _vm.url,
      title: _vm.$t("chatbots.dashboard.title"),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }